module.exports = __webpack_public_path__ + "img/Inflammation-CRC_10X_TGSP.93afc23d.png";